const poles = [
    {
        pole: "campagne",

    },
    {
        pole: "Gros Caf",
        respo: "Arnault",
        href: "gros-caf.html"
    },
    {
        pole: "paninis salés",
        respo: "Louis DB",
        href: "paninis-sales.html"
    },
    {
        pole: "décoration de Noël",
        respo: "Florian"
    },
    {
        pole: "pépins torréfiés",
        respo: "Louis M"
    },
    {
        pole: "citrouilles",
        respo: "Alexandre",
        href: "citrouille.html"
    },
    {
        pole: "parterre fleuri",
        respo: "Guillaume",
        href: "parterre-fleuri.html"
    },
    {
        pole: "mousse au chocolat",
        respo: "Quentin"
    },
    {
        pole: "salade de frits",
        respo: "Jana"
    },
    {
        pole: "gestion de pole",
        respo: "Mathieu"
    },
    {
        pole: "marché",
        respo: "Basile"
    },
    {
        pole: "savon",
        respo: "Mathieu"
    },
    {
        pole: "enjaille",
        respo: "Matthias"
    },
    {
        pole: "animal mythologique",
        respo: "Antoine"
    },
    {
        pole: "Psytrance",
        respo: "Mathieu"
    },
    {
        pole: "ethylotest",
        respo: "Anas",
        href: "ethylo/ethylotest.html"
    },
    {
        pole: "pâtes",
        respo: "Tom",
        href: "pates/pates.html"
    },
    {
        pole: "Réparation",
        respo: "Mikael"
    },
    {
        pole: "Neige",
        respo: "Alexis Winter"
    },
    {
        pole: "Snacup",
        respo: "Laure - Amélie"
    },
    {
        pole: "coucher de soleil",
        respo: "Axalia"
    },
    {
        pole: "Corbeau",
        respo: "Antoine"
    },
    {
        pole: "baguettes",
        respo: "Jochou"
    },
    {
        pole: "haïku",
    },
    {
        pole: "pansement chaterton",
        respo: "Noé"
    },
    {
        pole: "galet",
        respo: "Antoine"
    },
    {
        pole: "billard avec les objets incongrus",
    },
    {
        pole: "cerf - volant",
        respo: "Antoine"
    },
    {
        pole: "Recherche",
        respo: "Nathan"
    },
    {
        pole: "escalier",
        respo: "Baptiste & Noé"
    },
    {
        pole: "Création",
        respo: "Nathan"
    },
    {
        pole: "Détente",
        respo: "Henry"
    },
    {
        pole: "Chaos",
        respo: "Noé"
    },
    {
        pole: "Galettes des rois",
        respo: "Nathan"
    },
    {
        pole: "Origami",
        respo: "Noé"
    },
    {
        pole: "Petit Morceaux",
        respo: "Claire"
    },
    {
        pole: "Panini",
        respo: "Nathan"
    },
    {
        pole: "Maman",
        respo: "Alexandra"
    },
    {
        pole: "Fleur",
        respo: "Martin"
    },
    {
        pole: "feu d'artifice ",
        respo: "Anas"
    },
    {
        pole: "Crochet",
    },
    {
        pole: "Fripe",
        respo: "Anna"
    },
    {
        pole: "Paul",
        respo: "Paul"
    },
    {
        pole: "Balade",
        respo: "Martin"
    },
    {
        pole: "trop CON",
        respo: "huan"
    },
    {
        pole: "Communication",
        respo: "Antoine"
    },
    {
        pole: "Panologie"
    },
    {
        pole: "bataille de regard",
        respo: "Antoine"
    },
    {
        pole: "E - Sport Mario",
        respo: "Martin"
    },
    {
        pole: "pêche aux canard",
        respo: "Nathan"
    },
    {
        pole: "battle",
    },
    {
        pole: "math apéro",
    },
    {
        pole: "shifumi",
        respo: "Priam",
        href: "shifumi/shifumi.html"
    },
    {
        pole: "karaoké",
        respo: "Cyrine"
    },
    {
        pole: "Dragon",
    },
    {
        pole: "lasso pour pigeon",
        respo: "Anna"
    },
    {
        pole: "gourde",
        respo: "Daphnée"
    }
];

export default poles;